import React, {useMemo} from "react";
import {DropDownList} from "@progress/kendo-react-dropdowns";
import {useSelector} from "react-redux";

const OwnerJointTrustDropDown = (props) => {

    const trustListData = useSelector((state) =>
        state.dataStore.getIn(["trustList"])
    );

    const trustList = useMemo(() => {
        if (!trustListData) return [];
        return trustListData.toJS();
    }, [trustListData]);

    const handleChange = (e) => {

        if (e.target.value.value === "TRUST") {
            props.openAddTrustDialog(props.dataItem);
            return;
        }

        if (props.onChange) {
            props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: e.syntheticEvent,
                value: e.target.value.value,
            });
        }
    };

    const populateTrustOptions = (trustList, filterFn) => {
        const filteredList = (typeof filterFn !== 'function') ? trustList : trustList.filter(filterFn);
        return filteredList.map(item => ({value: item, text: item}));
    };

    const generateOptions = () => {
        let options = [{
            value: "CLIENT",
            text: "Client",
        }];

        if (OwnerJointTrustDropDown.hasSpouse) {
            options.push(
                {
                    value: "CO_CLIENT",
                    text: "Spouse",
                }
            );
        }

        const { dataItem } = props;
        if (dataItem["showJointTrustOptions"]) {
            options.push({
                value: "JOINT",
                text: "Joint"
            });

        }

        if (dataItem["showJointTrustOptions"] ) {
            options = options.concat(populateTrustOptions(trustList, props.filterFn));
        }

        if (props.allowNewTrusts && dataItem["showJointTrustOptions"]) {
            options.push({
                value: "TRUST",
                text: "+ Trust"
            });
        }

        return options;
    }

    const options= generateOptions();

    const { dataItem } = props;
    const field = props.field || "";
    const dataValue = dataItem[field] === null ? "" : dataItem[field];

    if (!dataItem.inEdit) {
        const selectedOption = options.find((c) => c.value === dataValue);
        return <td>
            {selectedOption.text}
        </td>
    }

    const getValidationOwner = () => {
        const isOwnerValid = options.find(e => e.value === props.dataItem.owner) !== undefined;
        return isOwnerValid;
    }

    return (
        <td>
            <DropDownList
                style={{
                    width: "100px",
                }}
                onChange={handleChange}
                value={options.find((c) => c.value === dataValue)}
                data={options}
                textField="text"
                valid={getValidationOwner()}
            />
        </td>
    );
};

export default OwnerJointTrustDropDown;
